import { useState, useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { isEmpty } from 'lodash-es';

import ReducerConstants from '../../constants/reducers';
import MediaService from '../../../services/MediaService';
import Media from '../../models/Media';
import { mediaMetaDataSlice } from '../../../redux/slices/media';
import renderLocale from '../../helpers/renderLocale';

const useMediaList = (tradeId: number) => {
  const dispatch = useDispatch();
  const mediaService = MediaService.get();
  const locale = renderLocale();

  const [multiMedia, setMultiMedia] = useState({
    metadata: {},
    media: []
  });

  const metadata = useSelector(
    state => state[ReducerConstants.MEDIA_METADATA],
    shallowEqual
  );

  // Get trade metadata if not available in redux store
  useEffect(() => {
    async function getMediaManageMetaData() {
      const response = await mediaService.getMediaManageMetaData();
      dispatch(
        mediaMetaDataSlice.actions.setMediaMetaData({ locale, ...response })
      );
    }

    if (isEmpty(metadata) || metadata?.locale !== locale) {
      getMediaManageMetaData();
    }
  }, [dispatch, locale, mediaService, metadata]);

  // Make medialist call
  useEffect(() => {
    if (!isEmpty(metadata)) {
      MediaService.getTradeMultimedia(tradeId).then(response => {
        setMultiMedia({ metadata, media: response?.media });
      });
    }
  }, [metadata, tradeId]);

  return new Media(multiMedia);
};

export default useMediaList;
